var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"title":'C端订单列表',"visible":_vm.visible,"width":'90vw',"maskClosable":false},on:{"cancel":_vm.close,"ok":_vm.close}},[_c('iframe',{staticStyle:{"height":"70vh","width":"100%"},attrs:{"src":_vm.src,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }